import { AppRouteProps } from "@bsm/component";
import { SchoolHolidayCreateContainer } from "./container/SchoolHolidayCreateContainer";

export const SchoolHolidayCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "BSMRH.Holiday.Create.Title",
        element: <SchoolHolidayCreateContainer />,
    },
    {
        path: ":id",
        title: "BSMRH.Holiday.Edit.Title", 
        element: <SchoolHolidayCreateContainer />,
    }
];